import config from '../../../constants/config';

// SnapChat Tracking Pixel
if (config.SNAPCHAT_TRACKING_PIXEL && config.SNAPCHAT_HASHED_EMAIL) {
    /* eslint-disable */
    (function (e, t, n) {
      if (e.snaptr) return;
      var a = (e.snaptr = function () {
        a.handleRequest
          ? a.handleRequest.apply(a, arguments)
          : a.queue.push(arguments);
      });
      a.queue = [];
      var s = 'script';
      var r = t.createElement(s);
      r.defer = !0;
      r.src = n;
      var u = t.getElementsByTagName(s)[0];
      u.parentNode.insertBefore(r, u);
    })(window, document, 'https://sc-static.net/scevent.min.js');
    snaptr('init', config.SNAPCHAT_TRACKING_PIXEL, {
      user_hashed_email: config.SNAPCHAT_HASHED_EMAIL,
    });
    snaptr('track', 'PAGE_VIEW');
    /* eslint-enable */
}



// WEBPACK FOOTER //
// ./src/assets/helpers/scripts/snapChat.js